import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import api from "../../services/api";
export default function useQueueList(companyId, socket) {
  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const sequence = useRef(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    const request = ++sequence.current;
    const cancel = axios.CancelToken.source();
    setLoading(true); setError(false);
    api.get("/queue", { timeout: 20000, cancelToken: cancel.token }).then(({ data }) => { if (request === sequence.current) setQueues(data); }).catch(err => { if (request === sequence.current && !axios.isCancel(err)) setError(true); }).finally(() => { if (request === sequence.current) setLoading(false); });
    return () => { sequence.current += 1; cancel.cancel(); };
  }, [companyId, revision]);
  useEffect(() => {
    if (!socket || !companyId) return undefined;
    let timer;
    const changed = data => { if (["create", "update", "delete"].includes(data?.action) && !timer) timer = setTimeout(() => { timer = null; refresh(); }, 350); };
    const event = `company-${companyId}-queue`; socket.on(event, changed);
    return () => { clearTimeout(timer); socket.off(event, changed); };
  }, [companyId, socket, refresh]);
  return { queues, loading, error, refresh };
}